<template>
  <div class="d-flex">
      <v-card
        width="300px"
      >
        <v-img :src="$url_img + item._source.photo" style="border-radius:2% 2% 0 0" height="150">
          <v-card-title v-if="event != 'event'" style="margin-top:-20px">
            <v-checkbox style="background:white;height:30px;width:25px" color="#c90000"
              v-model="item._score"
              @change="tandai(item)"
            ></v-checkbox>
          </v-card-title>
        </v-img>
        <v-list class="ml-4">
          <v-card-text  style="background:#E9F4F5;width:100%;color:#c90000">Id Iklan : {{item._source.id}}</v-card-text>
          <!-- <h3 class="mt-1" style="color:#c90000">TB Satuan Tertutup</h3> -->
          <h5 class="mt-1" style="color:#c90000" v-if="item._source.id_mst_iklan_jenis == 2 && item._source.id_mst_iklan_type == 3">
            {{ item._source.mst_iklan_type }} 
          </h5>
          <h5 class="mt-1" style="color:#c90000" v-else-if="item._source.id_mst_iklan_jenis == 2">
            {{ item._source.mst_iklan_jenis }}
            {{ item._source.mst_iklan_type }} {{ item._source.mst_type_tb }}
          </h5>
          <h5 class="mt-1" style="color:hsl(185, 66%, 37%)" v-else>
            {{ item._source.mst_iklan_jenis }}
          </h5>
          <h4 class="my-2" v-if="item._source.judul.length < 25">
            {{ item._source.judul }}
          </h4>
          <h4 class="my-2" v-else>
            {{ item._source.judul.substring(0, 25) + '..' }}
          </h4>

          <h5 
            v-if="
            item._source.harga_saat_ini == null &&
            item._source.id_mst_iklan_jenis == 1" style="color:#BABEC1">
            Harga
          </h5>
          <h5 
            v-if="
            item._source.harga_saat_ini == null &&
            item._source.id_mst_iklan_jenis == 2" style="color:#BABEC1">
            Harga Awal
          </h5>
          <h4 
            v-if="
            item._source.harga_saat_ini != null &&
            item._source.id_mst_iklan_jenis == 2" style="color:#BABEC1">
            Harga Saat Ini
          </h4>
          <h4 
            v-if="
            item._source.id_mst_iklan_jenis == 5" style="color:#BABEC1">
            Harga
          </h4>

          <h4 
            style="color:#F2994A"
            v-if="
              item._source.harga_saat_ini == null &&
              item._source.id_mst_iklan_jenis == 1"
          >
            Rp
                {{ Number(item._source.harga).toLocaleString('id-ID') }}
          </h4>
          <h4 
            style="color:#F2994A"
            v-if="
              item._source.harga_saat_ini == null &&
              item._source.id_mst_iklan_jenis == 2"
          >
            Rp
                {{ Number(item._source.harga_awal).toLocaleString('id-ID') }}
          </h4>
          <h4 
            style="color:#F2994A"
            v-if="
              item._source.harga_saat_ini != null &&
              item._source.id_mst_iklan_jenis == 2"
          >
            Rp
                {{ Number(item._source.harga_saat_ini).toLocaleString('id-ID') }}
          </h4>
          <h4 
            style="color:#F2994A"
            v-if="
              item._source.id_mst_iklan_jenis == 5"
          >
            Rp
                {{ Number(item._source.harga).toLocaleString('id-ID') }}
          </h4>

          <div class="d-flex">
            <v-icon
                color="blue"
                class="mr-1"
                small
              >
                mdi-check-decagram
              </v-icon>
              <span style="color:#000000" v-if="item._source.app_user.length < 15"> {{ item._source.app_user }}</span>
              <span class="my-2" v-else>
            {{ item._source.app_user.substring(0, 15) + '..' }}
          </span>
          </div>
          <div v-if="event != 'event'" class="d-flex my-1">
            <!-- <div class="py-1" style="cursor:pointer;color:#c90000;border:2px solid #c90000;width:80%;border-radius:7px"><center> Lihat Iklan</center></div> -->
           <v-btn color= "#c90000" outlined @click="go(item._source.id,item._source.judul)"> Lihat iklan </v-btn>
            <div class="py-1 ml-2" style="border:2px solid #BABEC1;border-radius:7px">
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-dots-vertical
                  </v-icon>
                </template>
                <v-list>
                    <v-list-item @click="dialogBekukan = true">Bekukan</v-list-item>
                </v-list>
              </v-menu>
            </div>
          </div>
          <div v-if="event == 'event'" class="d-flex my-1 mx-1">
            <div class="py-1" style="cursor:pointer;color:#c90000;border:2px solid #c90000;width:80%;border-radius:7px" @click="go(item._source.id,item._source.judul)"><center> Lihat</center></div>
            <div class="py-1 ml-2" style="cursor:pointer;color:#c90000;border:2px solid #c90000;width:80%;border-radius:7px"><center> Ubah</center></div>
            <div class="py-1 ml-2" style="border:2px solid #BABEC1;border-radius:7px">
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-dots-vertical
                  </v-icon>
                </template>
                <v-list>
                    <v-list-item @click="dialogBekukan = true">Hapus</v-list-item>
                </v-list>
              </v-menu>
            </div>
          </div>
        </v-list>
        
      </v-card>
      <v-dialog v-model="dialogBekukan" persistent max-width="500px">
      <v-card>
        <v-card-title>Kenapa iklan ini dihapus?</v-card-title>
        <v-textarea class="mx-3" v-model="alasanBekukan" solo></v-textarea>
        <v-card-actions style="margin-top: -15px">
          <v-spacer></v-spacer>
          <v-btn
            color="white"
            style="color: #c90000"
            @click="dialogBekukan = false"
          >
            Kembali
          </v-btn>
          <v-btn color="#c90000" :disabled="alasanBekukan == '' ? true : false" @click="bekukanIklan(item._source.id)" class="white--text"> Hapus Iklan </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

   
  </div>
</template>

<script>
import router from '../router';
export default {
  name: 'ListIklans',
  props: ['item','event'],
  data() {
    return {
      dialogBekukan:false,
      alasanBekukan: '',
    };
  },
  methods: {
    async tandai(param){
      this.$emit("DataTanda", param);
    },
    async bekukanIklan(param){
      let formData = new FormData();
      formData.append('id_biz_user', this.idAdmin);
      formData.append('alasan', this.alasanBekukan);
      formData.append('id_iklan', param)

      this.$req
        .post(this.$root.$baseapi.iklan+'/iklan/v3/take_down_iklan', formData)
        .then(response => {
          this.alasanBekukan = ''
          this.dialogBekukan = false
          // this.color.snackbar = 'success';
          // this.message = response.data.api_message;
          // this.snackbar = true;
          location.reload()
        })
        .catch(error => {
          this.color.snackbar = 'error';
          this.message = error.response.data.api_message;
          this.snackbar = true;
        });
    },
    async go(id,judul){
      this.$router.push(
          '/detail-iklan?id='+id+'&judul='+judul
      )
    }
  },
  created(){
    this.idAdmin = localStorage.getItem('id')
  }
}
</script>

<style>

</style>